import React, { Component } from 'react';
import { formValueSelector, reduxForm } from 'redux-form';
import { Grid, Button, Icon, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { ToolTipComponent, YesNoDialog } from 'Components';
import { ITEM_MAINTENANCE_BID_PRICE_FORM_NAME } from 'Common/FormEnum';
import { BidPriceEnum, UpdateBidPriceDetailsEnum } from 'Common/FieldEnum';
import { createToast, toastType } from 'Common/ToastHelper';
import { DropDownEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { ReactTableWrapperColumnProperties } from 'Common/Constants';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { PACK_SIZE_MESSAGE } from 'Common/Constants/inventory';
import { BracketTypeEnum } from 'Common/Constants/Enumeration/ItemMaintenanceEnum';

import {
  calculateCostPerServing,
  getLookupForGTINNumberAndVendor,
  isQtyPerUnitChanged,
  makeNewBidItem,
  validateItemBidPriceFormData,
} from '../helpers';
import {
  removeBidItem,
  getControlInfo,
  addNewBidItem,
  clearBidPriceError,
  updateBidPriceDetails,
  updateGridFormFields,
  getWarehouseWarning,
  resetWarehouseWarning,
  clearControlInfo,
  addNewPurchaseUnit,
  addNewSecUnit,
} from '../state/updateBidPriceDetails/actions';
import UpdateBidPriceDetailsComponent from '../components/UpdateBidPriceDetails';

let IdKey = 0;

class BidPrice extends Component {
  static propTypes = {
    removeBidItem: PropTypes.func.isRequired,
    getControlInfo: PropTypes.func.isRequired,
    addNewBidItem: PropTypes.func.isRequired,
    clearBidPriceError: PropTypes.func.isRequired,
    updateBidPriceDetails: PropTypes.func.isRequired,
    updateGridFormFields: PropTypes.func.isRequired,
    getWarehouseWarning: PropTypes.func.isRequired,
    resetWarehouseWarning: PropTypes.func.isRequired,
    clearControlInfo: PropTypes.func.isRequired,
    addNewPurchaseUnit: PropTypes.func.isRequired,
    addNewSecUnit: PropTypes.func.isRequired,

    bidPriceDetailsLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    controlInfoLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    warehouseWarningLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    submitError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    bidPriceDetailsData: PropTypes.object,
    selectedBidControlInfo: PropTypes.object,
    deletedBidIds: PropTypes.array,
    selectedBidRowIndex: PropTypes.number.isRequired,
    warehouseWarning: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    originalBidPriceData: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    isSubmitting: PropTypes.bool.isRequired,
    loadingBidPriceDetails: PropTypes.bool.isRequired,
    isDirty: PropTypes.bool.isRequired,
    loadingControlInfo: PropTypes.bool.isRequired,
    loadingWarehouseWarning: PropTypes.bool.isRequired,
    gridPreferenceLoading: PropTypes.bool.isRequired,
    gridPreferenceSubmitting: PropTypes.bool.isRequired,
    submitted: PropTypes.bool.isRequired,
  };
  static defaultProps = {
    bidPriceDetailsData: null,
    bidPriceDetailsLoadingError: null,
    controlInfoLoadingError: null,
    warehouseWarningLoadingError: null,
    submitError: null,
    originalBidPriceData: null,
    warehouseWarning: null,
    deletedBidIds: [],
    selectedBidControlInfo: null,
  };
  state = {
    isAddNewClicked: false,
    showQtyPerUnitForAddNewClick: false,
    showQtyPerUnitForOnRowClick: false,
    showUnitChangeModal: false,
    dropDownData: {
      showPopup: false,
      ItemId: null,
      BidId: null,
      prevValue: null,
      newValue: null,
      fieldName: null,
    },
    columns: [
      {
        Header: 'Bid Price',
        accessor: BidPriceEnum.PrimaryPrice,
        className: 'right-align',
        ...ReactTableWrapperColumnProperties,
        Cell: row => {
          let value = row.value;
          if (
            row.original &&
            row.original.BracketType !== BracketTypeEnum.None
          ) {
            if (
              row.original.BracketPricingDetails &&
              row.original.BracketPricingDetails.length > 0
            )
              value =
                row.original.BracketPricingDetails[0][
                  UpdateBidPriceDetailsEnum.Price
                ];
          }
          return <span>{value} </span>;
        },
      },
      {
        Header: 'Begin Date',
        accessor: BidPriceEnum.BeginDT,
        Cell: row => (
          <span>{moment(row.value).format(DATE_FORMAT_FOR_UI)} </span>
        ),
        filterMethod: (filter, row) => {
          if (filter.value === '') {
            return true;
          }
          const beginDt = row[filter.id]
            ? moment(row[filter.id]).format(DATE_FORMAT_FOR_UI)
            : '';
          return beginDt.includes(filter.value);
        },
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'End Date',
        accessor: UpdateBidPriceDetailsEnum.BidPriceEndDate,
        Cell: row => (
          <span>{moment(row.value).format(DATE_FORMAT_FOR_UI)} </span>
        ),
        filterMethod: (filter, row) => {
          if (filter.value === '') {
            return true;
          }
          const endDt = row[filter.id]
            ? moment(row[filter.id]).format(DATE_FORMAT_FOR_UI)
            : '';
          return endDt.includes(filter.value);
        },
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Unit',
        accessor: BidPriceEnum.Unit,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: () => {
          return (
            <ToolTipComponent
              label={'Pack Size'}
              popMessage={PACK_SIZE_MESSAGE}
              iconName="question circle outline"
            />
          );
        },
        visibilityName: 'Pack Size',
        accessor: BidPriceEnum.QtyPerUnit,
        className: 'right-align',
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Pack Unit',
        accessor: BidPriceEnum.SecondaryUnit,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Distributor',
        accessor: BidPriceEnum.VendorName,
        ...ReactTableWrapperColumnProperties,
      },
      {
        resizable: false,
        width: 50,
        sortable: false,
        filterable: false,
        Cell: rowInfo => {
          const { bidPriceDetailsData } = this.props;

          const hideRemoveIcon =
            bidPriceDetailsData.BidPriceDetails &&
            bidPriceDetailsData.BidPriceDetails.length === 1;
          let check = false;
          if (rowInfo.original.isNewAdded) {
            check = true;
          } else if (hideRemoveIcon) {
            check = false;
          } else {
            check = rowInfo.original.PrimaryPriceTextEnabled;
          }
          return check ? (
            <Icon
              name={'minus circle'}
              style={{
                cursor: 'pointer',
                color: '#df5a17',
              }}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.handleRemoveItem(e, rowInfo.original, rowInfo.index);
              }}
            />
          ) : (
            ''
          );
        },
      },
    ],
    resetPageOnDataChange: true,
  };
  reactTable = React.createRef();
  rowInfo = null;

  componentDidUpdate(prevProps) {
    const { clearBidPriceError } = this.props;
    if (this.props.submitted && !prevProps.submitted) {
      createToast(
        toastType.success,
        'Success',
        'Bid Price has been updated.',
        true
      );
      clearBidPriceError();
    }
    if (
      !prevProps.bidPriceDetailsData &&
      this.props.bidPriceDetailsData &&
      Array.isArray(this.props.bidPriceDetailsData.BidPriceDetails) &&
      this.props.bidPriceDetailsData.BidPriceDetails.length
    ) {
      const {
        ItemId,
        BidId,
      } = this.props.bidPriceDetailsData.BidPriceDetails[0];
      this.props.getControlInfo(ItemId, BidId, 0);
    }
    if (this.props.warehouseWarning === DropDownEnum.EmptyString) {
      const {
        showQtyPerUnitForAddNewClick,
        showQtyPerUnitForOnRowClick,
      } = this.state;
      showQtyPerUnitForAddNewClick && this.handleAddNewItem();
      showQtyPerUnitForOnRowClick && this.handleOnRowClick();
      this.props.resetWarehouseWarning();
    }
  }

  componentWillUnmount() {
    this.props.resetWarehouseWarning();
  }

  handleRemoveItem = (e, original, index) => {
    e.stopPropagation();
    const { removeBidItem, getControlInfo } = this.props;
    removeBidItem(original, index).then(() => {
      if (this.props.bidPriceDetailsData.BidPriceDetails.length) {
        const {
          BidId,
          ItemId,
        } = this.props.bidPriceDetailsData.BidPriceDetails[0];
        BidId && getControlInfo(ItemId, BidId, 0);
      }
    });
  };
  onRowClick = (state, rowInfo) => {
    const {
      bidPriceDetailsData,
      originalBidPriceData,
      selectedBidRowIndex,
      getWarehouseWarning,
    } = this.props;
    let style = {};
    if (rowInfo.index === this.props.selectedBidRowIndex) {
      style = {
        color: '#df5a17',
        fontWeight: '600',
      };
    }
    const obj1 = {
      onClick: e => {
        if (rowInfo && rowInfo.original) {
          this.rowInfo = rowInfo;
          const changedQtyPerUnit = isQtyPerUnitChanged(
            bidPriceDetailsData,
            originalBidPriceData,
            selectedBidRowIndex
          );
          const { QtyPerUnit, BidId } = bidPriceDetailsData.BidPriceDetails[
            selectedBidRowIndex
          ];
          //show modal, if pack size is changed only for existing bid item, skip for new bid item (bid id is 0 for new bid item)
          if (+BidId && changedQtyPerUnit) {
            this.setState(
              {
                showQtyPerUnitForOnRowClick: true,
              },
              () => {
                getWarehouseWarning(this.props.id, BidId, QtyPerUnit);
              }
            );
          } else {
            this.handleOnRowClick();
          }
        }
      },
      style: style,
    };
    return obj1;
  };
  handleOnRowClick = () => {
    const {
      getControlInfo,
      clearControlInfo,
      updateGridFormFields,
    } = this.props;
    this.setState(
      {
        BidId: this.rowInfo.original.BidId,
        isAddNewClicked: false,
      },
      () => {
        !this.rowInfo.original.isNewAdded &&
          this.rowInfo.original.BidId &&
          getControlInfo(
            this.rowInfo.original.ItemId,
            this.rowInfo.original.BidId,
            this.rowInfo.index
          );
        this.rowInfo.original.isNewAdded && clearControlInfo();
        updateGridFormFields(this.rowInfo.original, this.rowInfo.index);
      }
    );
    this.setState({
      showQtyPerUnitForOnRowClick: false,
    });
  };

  handleShowModalForUnitChange = result => {
    const {
      selectedBidRowIndex,
      originalBidPriceData,
      bidPriceDetailsData,
    } = this.props;
    const { newValue, fieldName } = this.state.dropDownData;
    const bidId =
      bidPriceDetailsData.BidPriceDetails[selectedBidRowIndex].BidId;
    const input = {
      newValue,
      prevValue: _.find(
        originalBidPriceData,
        bidItem => bidItem.BidId === bidId
      )[fieldName],
      selectedIndex: selectedBidRowIndex,
      fieldName,
    };
    if (result) {
      this.props.updateBidPriceDetails(input);
    } else {
      const updateToPrevValue = true;
      this.props.updateBidPriceDetails(input, updateToPrevValue);
    }
    this.setState({
      showUnitChangeModal: false,
    });
  };

  handleChange = (e, newValue, prevValue, fieldName) => {
    if (prevValue === newValue) {
      return;
    }

    const {
      selectedBidRowIndex,
      bidPriceDetailsData,
      updateBidPriceDetails,
    } = this.props;
    const obj = {
      newValue,
      prevValue,
      fieldName,
      selectedIndex: this.props.selectedBidRowIndex,
    };
    if (fieldName === BidPriceEnum.QtyPerUnit) {
      this.setState({
        dropDownData: obj,
      });
    }
    //show pop-up on change of unit/pack unit dropdown, for new bid item
    if (
      bidPriceDetailsData &&
      bidPriceDetailsData.BidPriceDetails &&
      bidPriceDetailsData.BidPriceDetails.length &&
      +bidPriceDetailsData.BidPriceDetails[selectedBidRowIndex].BidId &&
      (fieldName === BidPriceEnum.Unit ||
        fieldName === BidPriceEnum.SecondaryUnit) &&
      !bidPriceDetailsData.BidPriceDetails[selectedBidRowIndex].isNewAdded
    ) {
      this.setState({
        showUnitChangeModal: true,
        dropDownData: obj,
      });
    }
    if (
      fieldName === UpdateBidPriceDetailsEnum.BracketType &&
      (newValue === BracketTypeEnum.None || prevValue === BracketTypeEnum.None)
    ) {
      const valueObj = {
        newValue: [
          {
            FromBracket: 0,
            ToBracket: '',
            PerUnitValue: '0.0000',
            Price: '0.0000',
            toError: false,
            priceError: false,
          },
          {
            FromBracket: '',
            ToBracket: null,
            PerUnitValue: '0.0000',
            Price: '0.0000',
            toError: false,
            priceError: false,
          },
        ],
        prevValue: this.props.bracketPricingDetails,
        fieldName: UpdateBidPriceDetailsEnum.BracketPricingDetails,
        selectedIndex: this.props.selectedBidRowIndex,
      };
      updateBidPriceDetails(valueObj);
      this.props.change(
        UpdateBidPriceDetailsEnum.BracketPricingDetails,
        valueObj.newValue
      );
    }
    updateBidPriceDetails(obj);
    //here we are calculating cost per serving based on bid price and serving per unit
    if (
      fieldName === BidPriceEnum.ServingsPerUnit ||
      fieldName === BidPriceEnum.PrimaryPrice
    ) {
      const BidPriceDetails = this.props.bidPriceDetailsData
        ? this.props.bidPriceDetailsData.BidPriceDetails
        : [];
      if (BidPriceDetails.length) {
        this.props.change(
          BidPriceEnum.CostPerServing,
          +calculateCostPerServing(
            fieldName === BidPriceEnum.PrimaryPrice
              ? newValue
              : BidPriceDetails[this.props.selectedBidRowIndex][
                  BidPriceEnum.PrimaryPrice
                ],
            fieldName === BidPriceEnum.ServingsPerUnit
              ? newValue
              : BidPriceDetails[this.props.selectedBidRowIndex][
                  BidPriceEnum.ServingsPerUnit
                ]
          )
        );
      }
    }
  };

  addNewPurchaseUnit = (e, { value }) => {
    this.props.addNewPurchaseUnit(value);
  };

  addNewSecUnit = (e, { value }) => {
    this.props.addNewSecUnit(value);
  };

  handleAddNewItem = () => {
    const {
      addNewBidItem,
      bidPriceDetailsData,
      updateGridFormFields,
      selectedBidRowIndex,
    } = this.props;
    if (
      bidPriceDetailsData.BidPriceDetails &&
      bidPriceDetailsData.BidPriceDetails.length
    ) {
      const BidPriceDetails = _.cloneDeep(bidPriceDetailsData.BidPriceDetails);
      const { BidId } = bidPriceDetailsData.BidPriceDetails[
        selectedBidRowIndex
      ];
      const lookupForGTINNumberAndVendor = getLookupForGTINNumberAndVendor(
        BidPriceDetails
      );
      const key = ++IdKey;
      const newBidItem = makeNewBidItem(
        BidPriceDetails,
        BidId,
        key,
        lookupForGTINNumberAndVendor
      );
      if (newBidItem) {
        addNewBidItem(newBidItem);
        this.setState({
          IdKey: IdKey,
          isAddNewClicked: true,
        });
        updateGridFormFields(newBidItem, 0);
      }
    } else if (
      bidPriceDetailsData.BidPriceDetails &&
      !bidPriceDetailsData.BidPriceDetails.length
    ) {
      const newBidItem = _.cloneDeep(bidPriceDetailsData.NewBidPriceDetail);
      newBidItem.PrimaryPrice = '0.0000';
      newBidItem.SecondaryUnitWeight = '0.00';
      newBidItem.IdKey = IdKey;
      newBidItem[BidPriceEnum.BeginDT] = moment(
        bidPriceDetailsData.NewBidPriceDetail[BidPriceEnum.BeginDT]
      );
      newBidItem[UpdateBidPriceDetailsEnum.BidPriceEndDate] = moment(
        bidPriceDetailsData.NewBidPriceDetail[
          UpdateBidPriceDetailsEnum.BidPriceEndDate
        ]
      );
      newBidItem.isNewAdded = true;
      newBidItem.modified = true;
      addNewBidItem(newBidItem);
      this.setState({
        IdKey: IdKey,
        isAddNewClicked: true,
      });
      updateGridFormFields(newBidItem, 0);
    }
    const { newValue, prevValue, BidId } = this.state.dropDownData;
    this.props.updateBidPriceDetails({
      newValue,
      prevValue,
      BidId,
      selectedIndex: 0,
    });
    this.setState({
      showQtyPerUnitForAddNewClick: false,
    });
  };

  handleShowModalForAddNew = result => {
    this.props.clearControlInfo();
    if (result) {
      this.handleAddNewItem();
    } else {
      const {
        bidPriceDetailsData,
        selectedBidRowIndex,
        originalBidPriceData,
      } = this.props;
      const newQtyPerUnit =
        bidPriceDetailsData.BidPriceDetails[selectedBidRowIndex][
          BidPriceEnum.QtyPerUnit
        ];
      const prevQtyPerUnit =
        originalBidPriceData[selectedBidRowIndex][BidPriceEnum.QtyPerUnit];
      const updateToPrevValue = true;
      this.props.updateBidPriceDetails(
        {
          newValue: newQtyPerUnit,
          prevValue: prevQtyPerUnit,
          selectedIndex: selectedBidRowIndex,
          fieldName: BidPriceEnum.QtyPerUnit,
        },
        updateToPrevValue
      );
    }
    this.props.resetWarehouseWarning();
    this.setState({
      showQtyPerUnitForAddNewClick: false,
    });
  };

  handleShowModalForOnRowClick = result => {
    this.props.clearControlInfo();
    if (result) {
      this.handleOnRowClick();
    } else {
      const updateToPrevValue = true;
      this.props.updateBidPriceDetails(
        this.state.dropDownData,
        updateToPrevValue
      );
    }
    this.props.resetWarehouseWarning();
    this.setState({
      showQtyPerUnitForOnRowClick: false,
    });
  };

  resetScroll = () => this.props.scrollMainTo(0, 0);
  onAddNewClick = () => {
    const {
      bidPriceDetailsData,
      originalBidPriceData,
      selectedBidRowIndex,
      getWarehouseWarning,
    } = this.props;
    const changedQtyPerUnit = isQtyPerUnitChanged(
      bidPriceDetailsData,
      originalBidPriceData,
      selectedBidRowIndex
    );
    const { QtyPerUnit, BidId } = bidPriceDetailsData.BidPriceDetails[
      selectedBidRowIndex
    ];
    //show modal, if pack size is changed only for existing bid item, skip for new bid item (bid id is 0 for new bid item)
    if (+BidId && changedQtyPerUnit) {
      this.setState(
        {
          showQtyPerUnitForAddNewClick: true,
        },
        () => {
          getWarehouseWarning(this.props.id, BidId, QtyPerUnit);
        }
      );
    } else {
      this.handleAddNewItem();
    }
  };
  onResetPageOnDataChange = () => {
    this.setState({ resetPageOnDataChange: false });
  };
  componentDidMount() {
    if (this.props.isSaveButtonClicked) {
      const { touch } = this.props;
      const toTouch = [];
      toTouch.push(BidPriceEnum.Unit);
      toTouch.push(BidPriceEnum.QtyPerUnit);
      toTouch.push(BidPriceEnum.SecondaryUnit);
      toTouch.push(BidPriceEnum.VendorId);
      touch(...toTouch);
    }
  }

  render() {
    const {
      bidPriceDetailsData,
      loadingBidPriceDetails,
      getControlInfo,
      loadingControlInfo,
      selectedBidControlInfo,
      warehouseWarning,
      gridPreferenceLoading,
      gridPreferenceSubmitting,
      handleSubmit,
      primaryPrice,
      secondaryUnitWeight,
      secondaryUnitMeasure,
      secondaryUnitWeightGrams,
      loadingWarehouseWarning,
      bracketType,
    } = this.props;

    return (
      <React.Fragment>
        <Form onSubmit={handleSubmit}>
          <Grid className="grid-spacing">
            <Grid.Row>
              <Grid.Column width={4} floated={'right'} textAlign={'right'}>
                <Button
                  content="Add New"
                  type={'button'}
                  onClick={this.onAddNewClick}
                  loading={loadingWarehouseWarning}
                  disabled={loadingWarehouseWarning}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <UpdateBidPriceDetailsComponent
            bidPriceDetailsData={bidPriceDetailsData}
            loadingBidPriceDetails={loadingBidPriceDetails}
            columns={this.state.columns}
            getControlInfo={getControlInfo}
            onRowClick={this.onRowClick}
            handleChange={this.handleChange}
            selectedBidControlInfo={selectedBidControlInfo}
            loadingControlInfo={loadingControlInfo}
            gridPreferenceLoading={gridPreferenceLoading}
            gridPreferenceSubmitting={gridPreferenceSubmitting}
            reactTableRef={this.reactTable}
            primaryPrice={primaryPrice}
            resetPageOnDataChange={this.state.resetPageOnDataChange}
            onResetPageOnDataChange={this.onResetPageOnDataChange}
            addNewPurchaseUnit={this.addNewPurchaseUnit}
            addNewSecUnit={this.addNewSecUnit}
            secondaryUnitWeight={secondaryUnitWeight}
            secondaryUnitMeasure={secondaryUnitMeasure}
            secondaryUnitWeightGrams={secondaryUnitWeightGrams}
            loadingWarehouseWarning={loadingWarehouseWarning}
            bracketType={bracketType}
            handleLevelChange={this.handleLevelChange}
          />
        </Form>
        <YesNoDialog
          showDialog={
            this.state.showQtyPerUnitForAddNewClick &&
            warehouseWarning !== DropDownEnum.NullValue &&
            warehouseWarning !== DropDownEnum.EmptyString
          }
          title="Inventory"
          question={warehouseWarning}
          yesCallback={() => {
            this.handleShowModalForAddNew(true);
          }}
          noCallback={() => {
            this.handleShowModalForAddNew(false);
          }}
        />
        <YesNoDialog
          showDialog={
            this.state.showQtyPerUnitForOnRowClick &&
            warehouseWarning !== DropDownEnum.NullValue &&
            warehouseWarning !== DropDownEnum.EmptyString
          }
          title="Inventory"
          question={warehouseWarning}
          yesCallback={() => {
            this.handleShowModalForOnRowClick(true);
          }}
          noCallback={() => {
            this.handleShowModalForOnRowClick(false);
          }}
        />
        <YesNoDialog
          showDialog={this.state.showUnitChangeModal}
          title="Inventory"
          question={
            'The packaging description change will be cascaded to ALL prior transactions for this item\n' +
            'with the same QtyPerUnit. Are you sure?'
          }
          yesCallback={() => {
            this.handleShowModalForUnitChange(true);
          }}
          noCallback={() => {
            this.handleShowModalForUnitChange(false);
          }}
        />
      </React.Fragment>
    );
  }
}

const selector = formValueSelector(ITEM_MAINTENANCE_BID_PRICE_FORM_NAME);
const mapStateToProps = state => {
  const { gridPreference } = state.CommonState;
  const { updateBidPriceDetails, itemListing } = state.ItemMaintenanceState;
  const {
    bidPriceDetailsData,
    loadingBidPriceDetails,
    bidPriceDetailsLoadingError,
    selectedBidControlInfo,
    loadingControlInfo,
    controlInfoLoadingError,
    deletedBidIds,
    warehouseWarning,
    loadingWarehouseWarning,
    warehouseWarningLoadingError,
    isSubmitting,
    submitted,
    submitError,
    originalBidPriceData,
  } = updateBidPriceDetails;

  return {
    primaryPrice: selector(state, [BidPriceEnum.PrimaryPrice]),
    secondaryUnitWeight: selector(state, [BidPriceEnum.SecondaryUnitWeight]),
    secondaryUnitMeasure: selector(state, [BidPriceEnum.SecondaryUnitMeasure]),
    secondaryUnitWeightGrams: selector(state, [
      BidPriceEnum.SecondaryUnitWeightGrams,
    ]),
    bracketType: selector(state, [UpdateBidPriceDetailsEnum.BracketType]),
    bracketPricingDetails: selector(state, [
      UpdateBidPriceDetailsEnum.BracketPricingDetails,
    ]),
    bidPriceDetailsData,
    loadingBidPriceDetails,
    isDirty: getIsDirty()(state),
    bidPriceDetailsLoadingError,
    selectedBidControlInfo,
    loadingControlInfo,
    controlInfoLoadingError,
    deletedBidIds,
    selectedBidRowIndex: itemListing.selectedBidRowIndex,
    warehouseWarning,
    loadingWarehouseWarning,
    warehouseWarningLoadingError,
    originalBidPriceData,
    gridPreferenceLoading: gridPreference.loading,
    gridPreferenceSubmitting: gridPreference.isSubmitting,
    isSubmitting,
    submitted,
    submitError,
  };
};

BidPrice = reduxForm({
  form: ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
  validate: validateItemBidPriceFormData,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
})(BidPrice);

const mapDispatchToProps = {
  removeBidItem,
  getControlInfo,
  addNewBidItem,
  clearBidPriceError,
  updateBidPriceDetails,
  updateGridFormFields,
  getWarehouseWarning,
  resetWarehouseWarning,
  clearControlInfo,
  addNewPurchaseUnit,
  addNewSecUnit,
};
export default BidPrice = connect(
  mapStateToProps,
  mapDispatchToProps
)(BidPrice);



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/containers/BidPrice.js